import ResourceCentreContent from "./ResourceCentreContent";

export default ResourceCentreContent;